import { combineReducers } from "redux";
import {createWorkActivitiesReducer, 
    updateWorkActivityReducer,
    fetchWorkActivitiesReducer, 
    updateWorkActivityModalStatusReducer, 
    editWorkActivityReducer,
    newWorkActivityReducer,
    deleteWorkActivityReducer,
    updateImportantWorkActivityReducer
} from "./WorkActivities/WorkActivitiesReducer";

import {sendRequestBootcampSubscriptionReducer, fetchRequestBootcampSubscriptionReducer, updateBootcampSubscriptionReducer} from "./Subscription/BootcampSubscriptionReducer"

import {createAchievementsReducer, 
    updateAchievementsReducer,
    fetchAchievementsReducer, 
    updateAchievementsModalStatusReducer, 
    editAchievementsReducer,
    newAchievementsReducer,
    deleteAchievementsReducer,
    updateImportantAchievementsReducer
} from "./Achievements/AchievementsReducer";

import {createCoursesReducer, 
    updateCourseReducer,
    fetchCoursesReducer, 
    updateCourseModalStatusReducer, 
    editCourseReducer,
    newCourseReducer,
    deleteCourseReducer} from "./Courses/CoursesReducer";

import {createMcatScoresReducer, 
    updateMcatScoreReducer,
    fetchMcatScoresReducer, 
    updateMcatScoreModalStatusReducer, 
    editMcatScoreReducer,
    newMcatScoreReducer,
    deleteMcatScoreReducer} from "./McatScores/McatScoresReducer";

import {loginAuthReducer, adminUserReducer, renewTokenReducer, saveTimeSpentReducer} from "./UserAuthentication/LoginReducer";

import { fetchGradeReducer } from "./Grades/GradesReducer";

import { signupUserReducer } from "./UserAuthentication/RegisterReducer";
import { updateForgotPasswordModalStatusReducer, forgotPasswordReducer } from "./UserAuthentication/ForgotPasswordReducer";
import { resetPasswordReducer } from "./UserAuthentication/ResetPasswordReducer";

import { personalStatementReducer ,fetchPersonalStatementReducer} from "./PersonalStatement/PersonalStatementReducer";

import { fetchSchoolSearchReducer } from "./SchoolSearch/SchoolSearchReducer";
import { createSelectSchoolForSecondaryEssaysReducer, 
    fetchSelectSchoolForSecondaryEssaysReducer, 
    fetchResponseForSecondaryEssaysReducer, 
    createAnswersForSecondaryEssaysReducer,
    deleteSelectedSchoolForSecondaryEssayReducer,
    deleteResponseForSecondaryEssayReducer, updateSecondaryStatusReducer
} from "./SecondaryEssays/SecondaryEssaysReducer";
    

import {createProfilePictureReducer, updateUserProfileReducer, fetchUniversitiesReducer, updateUserPhoneNumberReducer, updateUserCommunitySettingsReducer, updateUserIntroductoryCallReducer} from "./Users/UsersReducer";
import {fetchSSOTokenReducer} from "./Ideas/IdeasReducer";
import {fetchAllUsersReducer, fetchUserDetailsReducer, updateUserDetailsReducer, updateMultiUsersReducer} from "./ManageUsers/ManageUsersReducer";
import { createCustomerReducer, createSubscriptionReducer , updateSubscriptionReducer , cancelSubscriptionReducer, manageSubscriptionModalStatusReducer, resumeSubscriptionReducer, fetchDetailsSubscriptionReducer, buyTutoringHoursModalStatusReducer, createTutoringHoursPaymentReducer, updateTutoringHoursAvailableReducer,createTpcCoursePaymentReducer,fetchPaymentRecordReducer, } from "./Payments/PaymentsReducer";
import {createReportedIssueReducer} from "./Support/SupportReducer"
import {
  createCoachTutorAvailabilityReducer, 
  fetchCoachTutorAvailabilityReducer, 
  fetchHistoryCoachTutorAvailabilityReducer, 
  deleteCoachTutorAvailabilityReducer,
  createWeeklyHoursCoachAvailabilityReducer,
  updateWeeklyHoursCoachAvailabilityReducer,
  fetchWeeklyHoursCoachAvailabilityReducer,
  deleteWeeklyHoursCoachAvailabilityReducer
} from "./ManageCoachTutorAvailability/ManageCoachTutorAvailabilityReducer"

import {fetchAvailableScheduleReducer, fetchScheduleReducer, createRequestTutorReducer, fetchRequestTutorReducer, cancelRequestTutorReducer, fetchRequestTutorHistoryReducer, fetchCoachesReducer} from "./ScheduleTutor/ScheduleTutorReducer"

import {fetchStudentRequestTutorReducer , approveStudentRequestTutorReducer, disapproveStudentRequestTutorReducer, fetchStudentRequestTutorHistoryReducer, updateModalUploadTutorVideoFileStatusReducer,editTutorRequestReducer,createStrUploadReducer } from "./ManageTutorRequests/ManageTutorRequestsReducer"

import {
  fetchAllCommunityPostsReducer,
  createCommunityPostReducer,
  updateCommunityPostReducer,
  deleteCommunityPostReducer,
  createCommunityCommentReducer,
  updateCommunityCommentReducer,
  deleteCommunityCommentReducer,
  createCommunityReplyReducer,
  updateCommunityReplyReducer,
  deleteCommunityReplyReducer,
  fetchCommunityLikedPostReducer,
  fetchLeaderboardReducer,
} from "./Community/CommunityReducer";

import {
  createProMemberPostReducer,
  updateCommunityProMemberPostReducer,
  deleteCommunityProMemberPostReducer,
  createCommunityProMemberCommentReducer,
  updateCommunityProMemberCommentReducer,
  deleteCommunityProMemberCommentReducer,
  createCommunityProMemberReplyReducer,
  updateCommunityProMemberReplyReducer,
  deleteCommunityProMemberReplyReducer,
} from "./Community/ProMemberReducer";


import {
  createTpcCourseReducer,
  updateTpcCourseReducer,
  fetchTpcCoursesReducer,
  deleteTpcCourseReducer,
  createTpcCourseCategoryReducer,
  createTpcCourseLessonsReducer,
  updateTpcCourseCategoryOrderReducer,
  updateTpcCourseCategoryReducer,
  updateTpcCourseLessonsReducer,
  deleteTpcCourseLessonsReducer,
  deleteTpcCourseCategoryReducer,
  updateMarkedCompleteLessonReducer,
  fetchMarkedCompleteLessonReducer,
  createBundleCoursesReducer,
  fetchBundleCoursesReducer,
  saveCoursesOrderReducer
} from "./ManageTpcCourses/ManageTpcCoursesReducer";


import {
  createDatCourseReducer,
  updateDatCourseReducer,
  fetchDatCoursesReducer,
  deleteDatCourseReducer,
  createDatCourseCategoryReducer,
  createDatCourseLessonsReducer,
  updateDatCourseCategoryOrderReducer,
  updateDatCourseCategoryReducer,
  updateDatCourseLessonsReducer,
  deleteDatCourseLessonsReducer,
  deleteDatCourseCategoryReducer,
  updateDatMarkedCompleteLessonReducer,
  fetchDatMarkedCompleteLessonReducer,
  createDatBundleCoursesReducer,
  fetchDatBundleCoursesReducer,
} from "./ManageDatCourses/ManageDatCoursesReducer";

  
import { covid19ImpactReducer ,fetchCovid19ImpactReducer} from "./Covid19Impact/Covid19ImpactReducer";
import { manualDexterityReducer ,fetchManualDexterityReducer} from "./ManualDexterity/ManualDexterityReducer";

import { createStudentToLifetimePlanReducer, fetchLtpItemReducer, deleteLtpItemReducer } from "./ManageLifeTimePlan/ManageLifeTimePlanReducer";

import { fetchQuestionBankReducer, createPracticeTestResultReducer, fetchPracticeTestAttemptsReducer } from "./DAT/DATReducer";


import {
  createUasPostReducer, 
  updateCommunityUasPostReducer,
  deleteCommunityUasPostReducer,
  createCommunityUasCommentReducer,
  updateCommunityUasCommentReducer,
  deleteCommunityUasCommentReducer,
  createCommunityUasReplyReducer,
  updateCommunityUasReplyReducer,
  deleteCommunityUasReplyReducer,} from "./Community/UasReducer"

import {createTimelineScheduleReducer} from "./Timeline/TimelineReducer";
import {fetchTimelineScheduleReducer} from "./Timeline/TimelineReducer";

import { messagesReducer } from "./Messages/MessagesReducer"
import { presenceReducer } from "./Messages/PresenceReducer";
import { threadsReducer } from "./Messages/ThreadsReducer";
import { usersPreptalkReducer } from "./Messages/UsersPrepTalkReducer";

import activeThreadReducer from "./Messages/ActiveThreadReducer";

import { fetchAppHourUsedLogsReducer, fetchAppLogReducer,fetchPremiumHourLogsReducer, sendEmailApplicationHourUsedReducer } from "./Logs/LogsReducer";

import { updateSettingsReducer, fetchSettingsReducer } from "./Settings/SettingsReducer";

// Question Bank
import { subjectsReducer, unitsReducer, topicsReducer } from "./QuestionBank/SubjectsUnitsReducer";
import { questionsReducer } from "./QuestionBank/QuestionsReducer";
import aiGenerationReducer from "./QuestionBank/AIGenerationReducer";
import { passageReducer } from "./QuestionBank/PassageReducer";
import { testProgressReducer } from "./QuestionBank/TestProgressReducer";
import { feedbackReducer } from "./QuestionBank/FeedbackReducer";
import adminAnalyticsReducer from "./QuestionBank/AdminAnalyticsReducer";
import fullLengthExamReducer from "./QuestionBank/FullLengthExamReducer";
import uploadLogsReducer from "./QuestionBank/UploadLogsReducer";

const rootReducer = combineReducers({

    sendRequestBootcampSubscription: sendRequestBootcampSubscriptionReducer,
    fetchRequestBootcampSubscription: fetchRequestBootcampSubscriptionReducer,
    updateBootcampSubscription: updateBootcampSubscriptionReducer,

    createWorkActivities: createWorkActivitiesReducer,
    updateWorkActivities: updateWorkActivityReducer,
    updateImportantWorkActivities: updateImportantWorkActivityReducer,
    fetchWorkActivities: fetchWorkActivitiesReducer,
    updateWorkActivityModalStatus: updateWorkActivityModalStatusReducer,
    editWorkActivity: editWorkActivityReducer,
    newWorkActivity: newWorkActivityReducer,
    deleteWorkActivity : deleteWorkActivityReducer,
    
    createCourses: createCoursesReducer,
    updateCourses: updateCourseReducer,
    fetchCourses: fetchCoursesReducer,
    updateCourseModalStatus: updateCourseModalStatusReducer,
    editCourse: editCourseReducer,
    newCourse: newCourseReducer,
    deleteCourse : deleteCourseReducer,

    createMcatScores: createMcatScoresReducer,
    updateMcatScores: updateMcatScoreReducer,
    fetchMcatScores: fetchMcatScoresReducer,
    updateMcatScoreModalStatus: updateMcatScoreModalStatusReducer,
    editMcatScore: editMcatScoreReducer,
    newMcatScore: newMcatScoreReducer,
    deleteMcatScore : deleteMcatScoreReducer,

    loginAuth: loginAuthReducer,
    fetchGrade: fetchGradeReducer,
    signupUser : signupUserReducer,

    updateForgotPasswordModalStatus : updateForgotPasswordModalStatusReducer,
    forgotPassword : forgotPasswordReducer,

    resetPassword : resetPasswordReducer,
    personalStatement : personalStatementReducer,
    fetchPersonalStatement : fetchPersonalStatementReducer,

    fetchSchoolSearch: fetchSchoolSearchReducer,
    
    
    createSelectSchoolForSecondaryEssays : createSelectSchoolForSecondaryEssaysReducer,
    fetchSelectSchoolForSecondaryEssays : fetchSelectSchoolForSecondaryEssaysReducer,
    fetchResponseForSecondaryEssays : fetchResponseForSecondaryEssaysReducer,
    createAnswersForSecondaryEssays : createAnswersForSecondaryEssaysReducer,
    deleteSelectedSchoolForSecondaryEssay : deleteSelectedSchoolForSecondaryEssayReducer,
    deleteResponseForSecondaryEssay : deleteResponseForSecondaryEssayReducer,
    updateSecondaryStatus : updateSecondaryStatusReducer,
    updateUserCommunitySettings: updateUserCommunitySettingsReducer,
    createProfilePicture : createProfilePictureReducer,
    updateUserProfile : updateUserProfileReducer,
    fetchUniversities: fetchUniversitiesReducer,
    fetchSSOToken : fetchSSOTokenReducer,
    fetchAllUsers : fetchAllUsersReducer,
    fetchUserDetails : fetchUserDetailsReducer,
    updateUserDetails : updateUserDetailsReducer,
    updateMultiUsers: updateMultiUsersReducer,
    createCustomer : createCustomerReducer,
    createSubscription : createSubscriptionReducer,
    updateSubscription : updateSubscriptionReducer,
    cancelSubscription : cancelSubscriptionReducer,
    manageSubscriptionModalStatus : manageSubscriptionModalStatusReducer,
    resumeSubscription : resumeSubscriptionReducer,
    fetchDetailsSubscription : fetchDetailsSubscriptionReducer,
    buyTutoringHoursModalStatus : buyTutoringHoursModalStatusReducer,
    createTutoringHoursPayment : createTutoringHoursPaymentReducer,
    createTpcCoursePayment: createTpcCoursePaymentReducer,
    fetchPaymentRecord: fetchPaymentRecordReducer,
    updateTutoringHoursAvailable : updateTutoringHoursAvailableReducer,
    createReportedIssue : createReportedIssueReducer,
    adminUser : adminUserReducer,
    renewToken : renewTokenReducer,
    saveTimeSpent: saveTimeSpentReducer,

    updateUserPhoneNumber : updateUserPhoneNumberReducer,

    createCoachTutorAvailability : createCoachTutorAvailabilityReducer,
    fetchCoachTutorAvailability : fetchCoachTutorAvailabilityReducer,
    fetchHistoryCoachTutorAvailability : fetchHistoryCoachTutorAvailabilityReducer,
    deleteCoachTutorAvailability : deleteCoachTutorAvailabilityReducer,
    createWeeklyHoursCoachAvailability : createWeeklyHoursCoachAvailabilityReducer,
    updateWeeklyHoursCoachAvailability : updateWeeklyHoursCoachAvailabilityReducer,
    fetchWeeklyHoursCoachAvailability : fetchWeeklyHoursCoachAvailabilityReducer,
    deleteWeeklyHoursCoachAvailability : deleteWeeklyHoursCoachAvailabilityReducer,

    fetchAvailableSchedule : fetchAvailableScheduleReducer,
    fetchSchedule : fetchScheduleReducer,
    createRequestTutor : createRequestTutorReducer,
    fetchRequestTutor : fetchRequestTutorReducer,
    cancelRequestTutor : cancelRequestTutorReducer,
    fetchStudentRequestTutor : fetchStudentRequestTutorReducer,
    approveStudentRequestTutor : approveStudentRequestTutorReducer,
    disapproveStudentRequestTutor : disapproveStudentRequestTutorReducer,
    fetchRequestTutorHistory : fetchRequestTutorHistoryReducer,
    fetchStudentRequestTutorHistory: fetchStudentRequestTutorHistoryReducer,
    updateModalUploadTutorVideoFileStatus: updateModalUploadTutorVideoFileStatusReducer,
    editTutorRequest: editTutorRequestReducer,
    createStrUpload: createStrUploadReducer,


    createAchievements: createAchievementsReducer,
    updateAchievements: updateAchievementsReducer,
    updateImportantAchievements: updateImportantAchievementsReducer,
    fetchAchievements: fetchAchievementsReducer,
    updateAchievementsModalStatus: updateAchievementsModalStatusReducer,
    editAchievement: editAchievementsReducer,
    newAchievement: newAchievementsReducer,
    deleteAchievement : deleteAchievementsReducer,

  fetchAllCommunityPosts: fetchAllCommunityPostsReducer,
  createCommunityPost: createCommunityPostReducer,
  updateCommunityPost: updateCommunityPostReducer,
  deleteCommunityPost: deleteCommunityPostReducer,
  createCommunityComment: createCommunityCommentReducer,
  updateCommunityComment: updateCommunityCommentReducer,
  deleteCommunityComment: deleteCommunityCommentReducer,
  createCommunityReply: createCommunityReplyReducer,
  updateCommunityReply: updateCommunityReplyReducer,
  deleteCommunityReply: deleteCommunityReplyReducer,
  fetchCommunityLikedPost: fetchCommunityLikedPostReducer,
  fetchLeaderboard: fetchLeaderboardReducer,

      createProMemberPost: createProMemberPostReducer,
  updateCommunityProMemberPost: updateCommunityProMemberPostReducer,
  deleteCommunityProMemberPost: deleteCommunityProMemberPostReducer,
  createCommunityProMemberComment: createCommunityProMemberCommentReducer,
  updateCommunityProMemberComment: updateCommunityProMemberCommentReducer,
  deleteCommunityProMemberComment: deleteCommunityProMemberCommentReducer,
  createCommunityProMemberReply: createCommunityProMemberReplyReducer,
  updateCommunityProMemberReply: updateCommunityProMemberReplyReducer,
  deleteCommunityProMemberReply: deleteCommunityProMemberReplyReducer,
  fetchCoaches: fetchCoachesReducer,

    createTpcCourse : createTpcCourseReducer,
    updateTpcCourse : updateTpcCourseReducer,
    fetchTpcCourses : fetchTpcCoursesReducer,
    deleteTpcCourse : deleteTpcCourseReducer,
    createTpcCourse : createTpcCourseReducer,
    updateTpcCourse : updateTpcCourseReducer,
    fetchTpcCourses : fetchTpcCoursesReducer,
    deleteTpcCourse : deleteTpcCourseReducer,
    createTpcCourseCategory : createTpcCourseCategoryReducer,
    createTpcCourseLessons : createTpcCourseLessonsReducer,
    updateTpcCourseCategoryOrder : updateTpcCourseCategoryOrderReducer,
    updateTpcCourseCategory : updateTpcCourseCategoryReducer,
    updateTpcCourseLessons : updateTpcCourseLessonsReducer,
    deleteTpcCourseLessons : deleteTpcCourseLessonsReducer,
    deleteTpcCourseCategory : deleteTpcCourseCategoryReducer,
    createBundleCourses: createBundleCoursesReducer,
    fetchBundleCourses:fetchBundleCoursesReducer,
    saveCoursesOrder: saveCoursesOrderReducer,
    updateMarkedCompleteLesson : updateMarkedCompleteLessonReducer,
    fetchMarkedCompleteLesson : fetchMarkedCompleteLessonReducer,

    createDatCourse : createDatCourseReducer,
    updateDatCourse : updateDatCourseReducer,
    fetchDatCourses : fetchDatCoursesReducer,
    deleteDatCourse : deleteDatCourseReducer,
    createDatCourse : createDatCourseReducer,
    updateDatCourse : updateDatCourseReducer,
    fetchDatCourses : fetchDatCoursesReducer,
    deleteDatCourse : deleteDatCourseReducer,
    createDatCourseCategory : createDatCourseCategoryReducer,
    createDatCourseLessons : createDatCourseLessonsReducer,
    updateDatCourseCategoryOrder : updateDatCourseCategoryOrderReducer,
    updateDatCourseCategory : updateDatCourseCategoryReducer,
    updateDatCourseLessons : updateDatCourseLessonsReducer,
    deleteDatCourseLessons : deleteDatCourseLessonsReducer,
    deleteDatCourseCategory : deleteDatCourseCategoryReducer,
    createDatBundleCourses: createDatBundleCoursesReducer,
    fetchDatBundleCourses:fetchDatBundleCoursesReducer,
    updateDatMarkedCompleteLesson : updateDatMarkedCompleteLessonReducer,
    fetchDatMarkedCompleteLesson : fetchDatMarkedCompleteLessonReducer,

   
    covid19Impact : covid19ImpactReducer,
    fetchCovid19Impact : fetchCovid19ImpactReducer,

    manualDexterity : manualDexterityReducer,
    fetchManualDexterity : fetchManualDexterityReducer,

    createStudentToLifetimePlan: createStudentToLifetimePlanReducer,
    fetchLtpItem: fetchLtpItemReducer,
    deleteLtpItem: deleteLtpItemReducer,
    fetchQuestionBank : fetchQuestionBankReducer,

    createPracticeTestResult: createPracticeTestResultReducer,
    fetchPracticeTestAttempts : fetchPracticeTestAttemptsReducer,
    updateUserIntroductoryCall: updateUserIntroductoryCallReducer,
    
    createCommunityUasPost: createUasPostReducer,
    updateCommunityUasPost: updateCommunityUasPostReducer,
    deleteCommunityUasPost: deleteCommunityUasPostReducer,
    createCommunityUasComment: createCommunityUasCommentReducer,
    updateCommunityUasComment: updateCommunityUasCommentReducer,
    deleteCommunityUasComment: deleteCommunityUasCommentReducer,
    createCommunityUasReply: createCommunityUasReplyReducer,
    updateCommunityUasReply: updateCommunityUasReplyReducer,
    deleteCommunityUasReply: deleteCommunityUasReplyReducer,

    createTimelineSchedule : createTimelineScheduleReducer,
    fetchTimelineSchedule : fetchTimelineScheduleReducer,

    messages : messagesReducer,
    presence : presenceReducer,
    threads : threadsReducer,
    usersPreptalk: usersPreptalkReducer,

    activeThread : activeThreadReducer,

    fetchAppHourUsedLogs: fetchAppHourUsedLogsReducer,
    fetchAppLog: fetchAppLogReducer,
    fetchPremiumHourLogs:fetchPremiumHourLogsReducer,
    sendEmailApplicationHourUsed: sendEmailApplicationHourUsedReducer,

    updateSettings : updateSettingsReducer,
    fetchSettings : fetchSettingsReducer,

    // Question Bank
    questionBankSubjects: subjectsReducer,
    questionBankUnits: unitsReducer,
    questionBankQuestions: questionsReducer,
    aiGeneration: aiGenerationReducer,
    questionBankPassages: passageReducer,
    testProgress: testProgressReducer,
    questionBankTopics: topicsReducer,
    questionBankFeedback: feedbackReducer,
    adminAnalytics: adminAnalyticsReducer,
    fullLengthExams: fullLengthExamReducer,
    uploadLogs: uploadLogsReducer,
});

export default rootReducer;